import { setHeaderTab } from '@/slices/menu/menuSlices';
import { useDispatch } from 'react-redux';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { useIsVisible } = require('react-is-visible');

export const useTrackIdUpdateLink = (ref: any, id?: string) => {
  const dispatch = useDispatch();
  const isVisible = useIsVisible(ref);
  if (isVisible && id) {
    dispatch(setHeaderTab(id));
  }
};
